<template>
  <div class="template">
    <div
      class="title-area"
      :style="{ backgroundImage: `url(${bannerlis.img == undefined ?'': domain + bannerlis.img})` }"
    >
      <div class="wrap">
        <div class="top-wrap">
          <div class="title">
            <slot name="title"></slot>
          </div>
          <span class="english-title">
            <slot name="english-title"></slot>
          </span>
        </div>
      </div>
    </div>
    <div class="crumb">
      <div class="wrap">
        <slot name="crumb"></slot>
      </div>
    </div>
    <div class="content-area wrap2">
       <slot name="other"> </slot>
      <!-- <div class="item wrap2">
        <div class="caption">产品概述</div>
        <div class="info detail">
          <slot name="detail"> </slot>
        </div>
        <div class="caption">产品架构</div>
        <div class="info">
          <slot name="info"> </slot>
        </div>
        <div class="caption">产品优势</div>
        <div class="info">
          <slot name="info2"> </slot>
        </div>
      </div> -->
    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import { banner } from "../network/http_api";
import Footer from "./footer.vue";
import { BASEDOMAIN } from "../common/config";


export default {
  data() {
    return {
      domain: "",
      bannerlis: {},
    };
  },
  components: {
    Footer,
  },
  methods: {
    async getBanner() {
      let res = await banner(2);
      if (res.code == 200) {
        this.bannerlis = res.data[0];
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
  },
  mounted() {
    this.domain = BASEDOMAIN;
        //console.log("banner123");
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
    this.getBanner()
  },
};
</script>

<style lang='scss' scoped>
.template {
  // margin-top: 64px;
  .wrap {
    width: 1200px;
    margin: 0 auto;
  }
  .wrap2 {
    width: 900px;
    margin: 0 auto;
  }
  .title-area {
    height: 450px;
    background: url("") no-repeat;
    background-size: cover;
    overflow: hidden;
    .top-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 150px;
    }
    .title {
      font-size: 64px;
      font-weight: 600;
      color: #ffffff;
      line-height: 75px;
      margin-bottom: 25px;
    }
    .english-title {
      font-size: 32px;
      font-weight: 400;
      color: #ffffff;
      line-height: 38px;
    }
  }
  .crumb {
    margin-top: 32px;
    margin-bottom: 20px;
  }
  .content-area {
    margin-bottom: 97px;
    .item {
      .caption {
        display: inline-block;
        font-size: 24px;
        font-weight: 500;
        color: #202020;
        padding: 8px 17px;
        margin: 42px 0 42px 50%;
        transform: translateX(-50%);
        border-bottom: 4px solid #1d7bff;
      }
      .info {
        color: #606266;
        img {
          width: 100%;
        }
      }
      .detail {
        color: #606266;
      }
    }
  }
}
</style>